export default "__VITE_ASSET__2Os_Uyfq__"